/**
 * Which steps of a ```guide the reader has ticked off, kept per browser so a
 * setup done over several days picks up where it was left. Keyed by the
 * guide's title, so two guides on one page never share progress.
 */

const PREFIX = 'cgt.wiki.guide.'

export function guideKey(title: string): string {
  const slug = title.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '')
  return PREFIX + (slug || 'guide')
}

/** Step titles marked done, dropping any no longer in the guide. */
export function readDone(raw: string | null, titles: string[]): Set<string> {
  if (!raw) return new Set()
  try {
    const parsed: unknown = JSON.parse(raw)
    if (!Array.isArray(parsed)) return new Set()
    return new Set(parsed.filter((t): t is string => typeof t === 'string' && titles.includes(t)))
  } catch {
    return new Set()
  }
}

/** The first step not yet done, or the last step when every one is. */
export function firstOpenStep(titles: string[], done: Set<string>): number {
  const i = titles.findIndex(t => !done.has(t))
  return i === -1 ? Math.max(0, titles.length - 1) : i
}
